'use client';

import React from 'react';
import { useRouter } from 'next/navigation';

import { Button } from '@shaojiang/components/ui/button';
import useLocale from '@shaojiang/hooks/useLocale';
import { defaultLocale } from '@shaojiang/i18n/config';

interface Props {
  /** The other language's name, e.g. "中文" on the English site */
  label: string;
  title: string;
}

/** Switches between English and Chinese on the same page. */
export function LanguageToggle({ label, title }: Props) {
  const router = useRouter();
  const { locale, pathName } = useLocale();
  const next = (locale || defaultLocale) === 'en' ? 'zh' : 'en';

  return (
    <Button
      variant='ghost'
      size='sm'
      title={title}
      aria-label={title}
      onClick={() => router.push(`/${next}${pathName === '/' ? '' : pathName}`)}
    >
      {label}
    </Button>
  );
}
